import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSubscriptionCoupons } from "../../services/apiV2";
import { TGetSubscriptionCouponsRes } from "../../services/apiV2.types";

export const fetchSubscriptionCoupons = createAsyncThunk<
  TGetSubscriptionCouponsRes,
  void,
  { rejectValue: unknown }
>("subscriptionCoupons/fetchSubscriptionCoupons", async (_, { rejectWithValue, signal }) => {
  try {
    const res = await getSubscriptionCoupons({ config: { signal } });
    return res.data;
  } catch (e) {
    return rejectWithValue(e);
  }
});
